<template>
<div>
  <van-nav-bar title="签约奖励" left-text="" left-arrow @click-left="onClickLeft()">
  </van-nav-bar>
  
  <div style="height:600px;overflow-y:auto;">
    <div style="margin-top:5px;">
      <van-cell-group>
        <van-cell title="当前单量" :value="totalnum" />
        <van-cell title="签约单量" :value="signnum" />
      </van-cell-group>
    </div>
    <div style="text-align:right;margin-top:1%;margin-right:20px;float:right;">
      <van-tag type="danger" size="large" @click="toSignEdit()">签约更改</van-tag>
    </div>
    <div style="text-align:right;margin-top:1%;margin-right:10px;float:right;">
      <van-tag type="danger" size="large" @click="toRewardLog()" style="marign-left:10px;">查看领取记录</van-tag>
    </div>
    <van-divider content-position="left">任务奖励</van-divider>
    <div style="margin-top:10px;">
      <van-cell-group inset style="margin-top:5px;margin-left:5px;margin-right:5px;" 
            v-for="(item,idx) in taskList" v-bind:key="idx">
        <van-cell :title="item.TaskType" value="" />
        <van-cell :title="item.Title" value="内容" :label="item.Describe" style="margin-top:5px;margin-bottom:5px;" 
              title-style="font-size:14px;font-weight:bold;padding-left:5px;">
          <!--签约单量任务-->
          <!-- <div v-if="(item.ID==1||item.ID==6||item.ID==11||item.ID==16)&&task1Count==1">
            <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>已领取</van-button>
          </div>
          <div v-else-if="(item.ID==1||item.ID==6||item.ID==11||item.ID==16)&&task1Count==0&&task1Process<100">
            <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>等待领取</van-button>
          </div> -->
          <!--额外奖励任务2-->
          <!-- <div v-else-if="(item.ID==2||item.ID==7||item.ID==12||item.ID==17)&&task2Count==1">
            <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>已领取</van-button>
          </div>
          <div v-else-if="(item.ID==2||item.ID==7||item.ID==12||item.ID==17)&&task2Count==0&&task2Process<100">
            <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>等待领取</van-button>
          </div> -->

          <!--增加单量任务-->
          <!-- <div v-else-if="(item.ID==3||item.ID==8||item.ID==13||item.ID==18)&&add10Process<100">
            <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>等待领取</van-button>
          </div> -->
          <!--额外奖励任务2（鳃网前置）-->
          <!-- <div v-else-if="(item.ID==4||item.ID==9||item.ID==14||item.ID==19)&&preFilterProcess<100">
            <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>等待领取</van-button>
          </div> -->
          <!--额外奖励任务3（暗装花洒）-->
          <!-- <div v-else-if="(item.ID==5||item.ID==10||item.ID==15||item.ID==20)&&conShowerProcess<100">
            <van-button type="danger" round size="mini" @click="receive(item.ID)" disabled>等待领取</van-button>
          </div>
          <div v-else>
            <van-button type="danger" round size="mini" @click="receive(item.ID)">立即领取</van-button>
          </div> -->

          <!--签约单量任务-->
          <div v-if="item.Type==1">
            <div v-if="task1Count==1">
              <van-button type="danger" round size="mini" disabled>已领取</van-button>
            </div>
            <div v-else-if="task1Count==0&&task1Process<100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else>
              <van-button type="danger" round size="mini" @click="receive(item.ID)">立即领取</van-button>
            </div>
          </div>
          <!--额外奖励任务2-->
          <div v-else-if="item.Type==2">
            <div v-if="task2Count==1">
              <van-button type="danger" round size="mini" disabled>已领取</van-button>
            </div>
            <div v-else-if="task1Count==0&&task2Count==0&&task2Process<100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else-if="task1Count==0&&task2Count==0&&task2Process==100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else-if="task1Count==1&&task2Count==0&&task2Process<100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else>
              <van-button type="danger" round size="mini" @click="receive(item.ID)">立即领取</van-button>
            </div>
          </div>
          <!--增加单量任务-->
          <div v-else-if="item.Type==3">
            <div v-if="task1Count==0&&add10Process<100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else-if="task1Count==0&&add10Process==100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else-if="task1Count==1&&add10Process<100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else>
              <van-button type="danger" round size="mini" @click="receive(item.ID)">立即领取</van-button>
            </div>
          </div>
          <!--额外奖励任务2（鳃网前置）-->
          <div v-else-if="item.Type==4">
            <div v-if="task1Count==0&&preFilterProcess<100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else-if="task1Count==0&&preFilterProcess==100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else-if="task1Count==1&&preFilterProcess<100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else>
              <van-button type="danger" round size="mini" @click="receive(item.ID)">立即领取</van-button>
            </div>
          </div>
          <!--额外奖励任务3（暗装花洒）-->
          <div v-else-if="item.Type==5">
            <div v-if="task1Count==0&&conShowerProcess<100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else-if="task1Count==0&&conShowerProcess==100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else-if="task1Count==1&&conShowerProcess<100">
              <van-button type="danger" round size="mini" disabled>等待领取</van-button>
            </div>
            <div v-else>
              <van-button type="danger" round size="mini" @click="receive(item.ID)">立即领取</van-button>
            </div>
          </div>
          
          <!-- 使用 icon 插槽来自定义左侧图标 -->
          <template #icon v-if="item.Level==1">
            <img width="40" height="45" src="../../assets/draw2025/reward_1000.png" alt="" style="margin-top:5px;" v-if="item.ID==1">
            <img width="40" height="45" src="../../assets/draw2025/reward_200.png" alt="" style="margin-top:5px;" v-if="item.ID==2">
            <img width="40" height="45" src="../../assets/draw2025/reward_400.png" alt="" style="margin-top:5px;" v-if="item.ID==3">
            <img width="40" height="45" src="../../assets/draw2025/reward_100.png" alt="" style="margin-top:5px;" v-if="item.ID==4">
            <img width="40" height="45" src="../../assets/draw2025/reward_100.png" alt="" style="margin-top:5px;" v-if="item.ID==5">
          </template>
          <template #icon v-else-if="item.Level==2">
            <img width="40" height="45" src="../../assets/draw2025/reward_2400.png" alt="" style="margin-top:5px;" v-if="item.ID==6">
            <img width="40" height="45" src="../../assets/draw2025/reward_400.png" alt="" style="margin-top:5px;" v-if="item.ID==7">
            <img width="40" height="45" src="../../assets/draw2025/reward_500.png" alt="" style="margin-top:5px;" v-if="item.ID==8">
            <img width="40" height="45" src="../../assets/draw2025/reward_100.png" alt="" style="margin-top:5px;" v-if="item.ID==9">
            <img width="40" height="45" src="../../assets/draw2025/reward_100.png" alt="" style="margin-top:5px;" v-if="item.ID==10">
          </template>
          <template #icon v-else-if="item.Level==3">
            <img width="40" height="45" src="../../assets/draw2025/reward_4200.png" alt="" style="margin-top:5px;" v-if="item.ID==11">
            <img width="40" height="45" src="../../assets/draw2025/reward_600.png" alt="" style="margin-top:5px;" v-if="item.ID==12">
            <img width="40" height="45" src="../../assets/draw2025/reward_600.png" alt="" style="margin-top:5px;" v-if="item.ID==13">
            <img width="40" height="45" src="../../assets/draw2025/reward_100.png" alt="" style="margin-top:5px;" v-if="item.ID==14">
            <img width="40" height="45" src="../../assets/draw2025/reward_100.png" alt="" style="margin-top:5px;" v-if="item.ID==15">
          </template>
          <template #icon v-else-if="item.Level==4">
            <img width="40" height="45" src="../../assets/draw2025/reward_6400.png" alt="" style="margin-top:5px;" v-if="item.ID==16">
            <img width="40" height="45" src="../../assets/draw2025/reward_800.png" alt="" style="margin-top:5px;" v-if="item.ID==17">
            <img width="40" height="45" src="../../assets/draw2025/reward_700.png" alt="" style="margin-top:5px;" v-if="item.ID==18">
            <img width="40" height="45" src="../../assets/draw2025/reward_100.png" alt="" style="margin-top:5px;" v-if="item.ID==19">
            <img width="40" height="45" src="../../assets/draw2025/reward_100.png" alt="" style="margin-top:5px;" v-if="item.ID==20">
          </template>
        </van-cell>
        <!--任务进度-->
        <div style="width:90%;margin-left:5%;margin-right:5%;padding-bottom:5px;" v-if="item.ID==1||item.ID==6||item.ID==11||item.ID==16">
          <van-progress color="#f2826a" :percentage="task1Process" :stroke-width="3"/>
        </div>
        <div style="width:90%;margin-left:5%;margin-right:5%;padding-bottom:5px;" v-if="item.ID==2||item.ID==7||item.ID==12||item.ID==17">
          <van-progress color="#f2826a" :percentage="task2Process" :stroke-width="3"/>
        </div>
        <div style="width:90%;margin-left:5%;margin-right:5%;padding-bottom:5px;" v-if="item.ID==3||item.ID==8||item.ID==13||item.ID==18">
          <van-progress color="#f2826a" :percentage="add10Process" :stroke-width="3"/>
        </div>
        <div style="width:90%;margin-left:5%;margin-right:5%;padding-bottom:5px;" v-if="item.ID==4||item.ID==9||item.ID==14||item.ID==19">
          <van-progress color="#f2826a" :percentage="preFilterProcess" :stroke-width="3"/>
        </div>
        <div style="width:90%;margin-left:5%;margin-right:5%;padding-bottom:5px;" v-if="item.ID==5||item.ID==10||item.ID==15||item.ID==20">
          <van-progress color="#f2826a" :percentage="conShowerProcess" :stroke-width="3"/>
        </div>
      </van-cell-group>
    </div>
  </div>

</div>
  
</template>
<script>
import { Button, Cell, CellGroup, NavBar, NoticeBar, Progress, Tag,Image, Swipe, SwipeItem, Divider } from "vant";
export default {
  data() {
    return {
      rankText: "",
      reward: 0,
      reText: "",
      myCount: 0,
      taskList: [],
      add10Process:0,
      preFilterProcess:0,
      conShowerProcess:0,
      task1Process:0,
      task2Process:0,
      task1Count:0,
      task2Count:0,
      totalnum:0,
      signnum:0,
    };
  },
  created() {
    console.log(this.$route)
    if(this.$route.params.fromWechat){
      this.$router.go(0);
    }
    this.GetActivityPeriod();
    this.GetData();
    this.QueryProcess();
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    GetActivityPeriod() {
      var that = this;
      this.$http.get("Activity2025/GetMemReward", {
        params: {
          period: 1,
        },
      }).then((res) => {
        that.totalnum = res.data.Data.TotalNum;
        that.signnum = res.data.Data.SignNum;
      });
    },
    receive(id) {
      var that = this;
      that.$http.get("Activity2025/GetUserActivityReward", {
          params: {
            taskId:id
          },
        }).then((res) => {
          if (res.data == "success") {
            that.$toast("领取成功！");
            that.QueryProcess();        
          } else {
            that.$toast(res.data);
          }
        });
    },
    GetData() {
      var that = this;
      this.$http.get("Activity2025/GetTaskList", {
        params: {
          pageIndex: 1,
        },
      }).then((res) => {
        that.taskList = res.data.ListData;
        that.$toast.clear();
      });
    },
    QueryProcess() {
      var that = this;
      that.$http.get("Activity2025/QueryProcessNum", {
          params: {},
        }).then((res) => {
          if (res.data.Msg == "success") 
          {
            that.add10Process=res.data.Data.Add10Process;  
            that.preFilterProcess=res.data.Data.PreFilterProcess;
            that.conShowerProcess=res.data.Data.ConShowerProcess;
            that.task1Process=res.data.Data.Task1Process;
            that.task2Process=res.data.Data.Task2Process;
            that.task1Count=res.data.Data.Task1Count;
            that.task2Count=res.data.Data.Task2Count;
          } else {
            that.$toast(res.data);
          }
        });
    },
    toRewardLog() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "Reward2025LogList",
        params: {},
      });
    },
    toSignEdit() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "SignEdit",
        params: {},
      });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [NoticeBar.name]: NoticeBar,
    [NavBar.name]: NavBar,
    [Progress.name]: Progress,
    [Image.name]: Image,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Divider.name]: Divider,
  },
};
</script>
<style scoped>


.image
{
  width:177px;
  height:35px;
  position:relative; 
}

@keyframes flicker{
0%,100%{
transform:scale(1);
-moz-transform:scale(1);
-o-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
opacity:1
}
90%{
transform:scale(0.9);
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
opacity:1
}

}
@-webkit-keyframes flicker{
0%,100%{
-webkit-transform:scale(1);
-moz-transform:scale(1);
-o-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-webkit-transform:scale(0.9);
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
@-moz-keyframes flicker{
0%,100%{
-moz-transform:scale(1);
-o-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
@-o-keyframes flicker{
0%,100%{
-o-transform:scale(1);
-moz-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-o-transform:scale(0.9);
-moz-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
.image {
-webkit-animation:flicker 0.8s infinite ease-in-out;
-moz-animation:flicker 0.8s infinite ease-in-out;
-o-animation:flicker 0.8s infinite ease-in-out;
animation:flicker 0.8s infinite ease-in-out
}
.image {
animation-delay:-0.8s;
-webkit-animation-delay:-0.8s;
-moz-animation-delay:-0.8s;
-o-animation-delay:-0.8s
}
</style>
